import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import UiKit from '../../../../../shared/ui/ui-kit';
import { colorsPalette } from '../../../../../shared/ui/styles/colors-palette';
import { Trans, useTranslation } from 'react-i18next';
import { useUILogic } from '../../../shared/providers/UILogicProvider/hooks';
import EmailSentIcon from '../../../shared/assets/EmailSent.svg';

interface RecoveryWaitEmailProps {}

let RecoveryWaitEmail = function ({}: RecoveryWaitEmailProps): ReactElement {
  const { t } = useTranslation();
  const { authorizationUiModule } = useUILogic();
  const restoreUIManager = authorizationUiModule.restorePasswordUIManager;
  const coreManager = restoreUIManager.coreManager;

  return (
    <Wrapper>
      <Heading>{t('recovery.heading')}</Heading>
      <IconWrapper>
        <img src={EmailSentIcon} alt="" />
      </IconWrapper>
      <SuccessMessage>
        <Trans
          i18nKey="recovery.success.message"
          values={{ email: coreManager.email }}
          components={{ strong: <UiKit.Text bold={true} /> }}
        />
      </SuccessMessage>
      <SpamNote>{t('recovery.success.spamNote')}</SpamNote>
      <RememberLink
        onClick={() => {
          coreManager.reset();
          authorizationUiModule.module.openLoginPage();
        }}
      >
        {t('recovery.rememberedPassword')}
      </RememberLink>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;
const Heading = styled.div`
  font-family: 'SkorozvonRoboto';
  font-weight: 500;
  font-size: 38px;
  line-height: 46px;
  color: ${colorsPalette.gray700};
  text-align: center;
`;
const IconWrapper = styled.div`
  display: flex;
  justify-content: center;

  img {
    display: block;
  }
`;
const SuccessMessage = styled.div`
  font-size: 14px;
  color: ${colorsPalette.gray600};
  text-align: center;
  line-height: 20px;
`;
const SpamNote = styled.div`
  font-size: 14px;
  color: ${colorsPalette.gray300};
  text-align: center;
`;
const RememberLink = styled.div`
  width: fit-content;
  align-self: center;
  font-size: 14px;
  line-height: 22px;
  color: ${colorsPalette.gray600};
  text-decoration: underline;
  cursor: pointer;
`;

RecoveryWaitEmail = observer(RecoveryWaitEmail);

export { RecoveryWaitEmail };
